import { defineMessages } from 'react-intl';

const messages = defineMessages({
  // A sign-in has TWO hops that can drop — Firebase's own endpoint, and the guarded
  // `/auth/me` that turns the credential into a session — and neither of them is a wrong
  // password. Announcing both as "invalid credentials" sent the user looking for a typo in
  // a credential the server never rejected, and the Firebase identity is deliberately kept
  // so pressing the button again is all it takes.
  signInNotCompleted: {
    id: 'auth.signInNotCompleted',
    defaultMessage:
      'We could not complete the sign-in. Check your connection and try again.',
  },
});

export default messages;
